<template>
  <div class="social-wrapper" dir="rtl">
    <div class="social-pill-container glass-effect">
      <div 
        v-for="(item, index) in displayedMedias" 
        :key="index" 
        class="social-icon-btn"
        :style="getDynamicStyle(item.name)"
        @click="handleClick(item)"
        v-tooltip="item.socialText || item.name"
      >
        <svg-base :view-box="getViewBox(item.name)" style="display: block; margin: auto;">
            <component :is="item.svg" class="mt-0" />
        </svg-base>
      </div>
    </div>

    <!-- دکمه نمایش بیشتر / کمتر -->
    <div v-if="medias.length > initialLimit" class="toggle-container mt-4">
      <div class="divider-line"></div>
      <div 
        class="toggle-btn text-caption font-weight-bold mx-3 glass-effect"
        @click="isExpanded = !isExpanded"
      >
        {{ isExpanded ? 'نمایش کمتر' : 'نمایش بیشتر' }}
        <v-icon small class="mr-1" color="white">
          {{ isExpanded ? 'mdi-chevron-up' : 'mdi-chevron-down' }}
        </v-icon>
      </div>
      <div class="divider-line"></div>
    </div>
  </div>
</template>

<script>
import SvgBase from "@/view/content/svgLoader/svgBase";

const viewBoxConfig = {
  // شبکه‌های اجتماعی ایرانی
  aparat: 40,
  gap: 40,

  // شبکه‌های اجتماعی خارجی
  linkedin_company: '-10 -10 60 60',
  github: 32,
  threads: 42,
  skype: 40,
  youtube: 40,
  wechat: 40,
  viber: 40,

  // سایت‌های آگهی و فروشگاهی
  divar: '0 0 40 24.33',
  sheypoor: 40,
  digikala: '0.00 0.00 1080.00 1080.00',
  basalam: '0 0 128 208',
  snappshop: '0 0 69 40',    
  technolife: '0 0 112 42',
  torob: '0.00 0.00 130.00 130.00',        
  emalls: '0.00 0.00 300.00 78.00',

  // استورها
  cafebazaar: '0.00 0.00 303.00 132.00',
  googleplay: '0 -4.447 361.403 408.86699999999996',
  samsung: '0 0 230 230',
  apple: '0 0 512 512',
}
export default {
  name: "SocialGrid2",
  components: { SvgBase },
  props: {
    medias: { type: Array, required: true, default: () => [] },
    getSocialColor: { type: Function, required: true },
    hexToRgba: { type: Function, required: true }
  },
  data() {
    return {
      isExpanded: false,
      initialLimit: 10, 
    };
  },
  computed: {
    displayedMedias() {
      if (this.isExpanded) {
        return this.medias;
      }
      return this.medias.slice(0, this.initialLimit);
    }
  },
  methods: {
    getViewBox(name) {
      return viewBoxConfig[name] || '0 0 50 50';
    },
    getDynamicStyle(name) {
      const color = this.getSocialColor(name);
      const isGradient = color.includes('gradient');
      
      return {
        '--hover-bg': isGradient ? 'transparent' : this.hexToRgba(color, 0.1),
        '--icon-color': isGradient ? 'transparent' : color,
        '--border-color': isGradient ? 'transparent' : this.hexToRgba(color, 0.4),
        '--shadow-color': isGradient ? 'transparent' : this.hexToRgba(color, 0.3),
        // اعمال بک‌گراند فقط برای مواردی مثل اینستاگرام که گرادیان دارند
        background: isGradient ? color : 'rgba(255, 255, 255, 0.05)', 
      };
    },
    handleClick(item) {
      this.$emit('go-to-url', item);
    }
  }
};
</script>

<style scoped>
.social-wrapper {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 100%;
  padding: 8px;
  box-sizing: border-box;
}

.social-pill-container {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: center;
  align-items: center;
  gap: 12px;
  width: 100%;
  max-width: 100%;
  padding: 16px 12px;
  border-radius: 24px; /* گوشه‌های گرد مناسب برای چند ردیف */
  box-sizing: border-box;
  background: rgba(255, 255, 255, 0.1);
  box-shadow: 0 8px 32px 0 rgba(0, 0, 0, 0.25), inset 0 0 10px rgba(255, 255, 255, 0.05);
  border: 1px solid rgba(255, 255, 255, 0.2);
}

/* استایل شیشه‌ای عمومی */
.glass-effect {
  backdrop-filter: blur(12px);
  -webkit-backdrop-filter: blur(12px);
}

.social-icon-btn {
  background: rgba(255, 255, 255, 0.42); /* رنگ پس‌زمینه محو برای دکمه‌ها */
  border: 1px solid rgba(255, 255, 255, 0.3); /* حاشیه روشن‌تر */
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.15); 
  width: 48px;
  height: 48px;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  transition: all 0.3s cubic-bezier(0.25, 0.8, 0.25, 1);
  position: relative;
  flex-shrink: 0;
  box-sizing: border-box;
}

.icon-svg {
  width: 24px;
  height: 24px;
  transition: transform 0.3s ease;
  z-index: 2;
  fill: #fff;
}

.social-icon-btn:hover {
  transform: translateY(-3px);
  background: var(--hover-bg) !important;
  border-color: var(--border-color);
  box-shadow: 0 6px 12px var(--shadow-color);
}

.social-icon-btn:hover .icon-svg {
  transform: scale(1.15);
  fill: var(--icon-color);
}

.social-icon-btn[style*="gradient"] {
  border: none;
}
.social-icon-btn[style*="gradient"] .icon-svg ::v-deep svg path {
  fill: #fff !important;
}

.toggle-container {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
}

.divider-line {
  flex-grow: 1;
  height: 1px;
  background: rgba(255, 255, 255, 0.2);
}

.toggle-btn {
  display: flex;
  align-items: center;
  padding: 6px 16px;
  border-radius: 20px;
  cursor: pointer;
  user-select: none;
  transition: all 0.3s ease;
  background: rgba(255, 255, 255, 0.1);
  border: 1px solid rgba(255, 255, 255, 0.2);
  color: white;
}

.toggle-btn:active {
  transform: scale(0.95);
}
.social-icon-btn ::v-deep svg {
  width: 30px;
  height: 30px;
  display: block;
  margin: auto;
}

.social-icon-btn ::v-deep svg * {
  max-width: 100%;
  max-height: 100%;
}

</style>
